export type SECTOR_KEY =
  | 'index'
  | 'tech'
  | 'ecommerce'
  | 'software'
  | 'semi'
  | 'reit'
  | 'game'
  | 'energy'
  | 'clothes'
  | 'f&b'
  | 'finance'
  | 'health'
  | 'retail'
  | 'travel'
  | 'ev'
  | 'media'
  | 'other';

export const titleBySector: Record<string, string> = {
  index: '지수',
  tech: '테크',
  ecommerce: '전자상거래',
  software: '소프트웨어',
  semi: '반도체',
  reit: '리츠',
  game: '게임',
  energy: '에너지',
  clothes: '신발/의류',
  'f&b': '식음료',
  finance: '금융',
  health: '건강',
  retail: '리테일',
  travel: '여행',
  ev: '전기차',
  media: '미디어',
  other: '기타',
};

export const symbolsBySector: Record<string, string[]> = {
  index: ['SPY', 'QQQ', 'DIA'],
  tech: ['AAPL', 'GOOGL', 'MSFT', 'FB', 'TWTR'],
  ecommerce: ['AMZN', 'BABA'],
  software: ['ADBE', 'CRM', 'ADSK', 'PLTR'],
  semi: ['NVDA', 'AMD', 'TSM', 'ASML'],
  reit: ['O'],
  game: ['U', 'ATVI'],
  energy: ['PLUG', 'XOM'],
  clothes: ['NKE', 'CROX', 'LULU'],
  'f&b': ['MCD', 'SBUX', 'KO', 'PEP'],
  finance: ['V', 'JPM', 'PYPL', 'BAC', 'MA'],
  health: ['JNJ', 'PFE', 'UNH', 'NVS'],
  retail: ['WMT', 'COST', 'PG', 'HD'],
  travel: ['ABNB', 'AAL', 'DAL', 'LUV'],
  ev: ['TSLA', 'GM', 'LCID'],
  media: ['NFLX', 'DIS'],
  other: [],
};

export type additionalDataType = {
  krShortName: string;
  sector: SECTOR_KEY;
};
export const additionalDataBySymbol: Record<string, additionalDataType> =
  (() => {
    const data: Record<string, any> = {
      SPY: { krShortName: 'S&P 500' },
      QQQ: { krShortName: '나스닥 100' },
      DIA: { krShortName: '다우존스' },
      AAPL: { krShortName: '애플' },
      GOOGL: { krShortName: '알파벳' },
      MSFT: { krShortName: '마이크로소프트' },
      AMZN: { krShortName: '아마존' },
      FB: { krShortName: '메타' },
      TWTR: { krShortName: '트위터' },
      NVDA: { krShortName: '엔비디아' },
      AMD: { krShortName: 'AMD' },
      TSM: { krShortName: 'TSMC' },
      O: { krShortName: '리얼티인컴' },
      MCD: { krShortName: '맥도날드' },
      SBUX: { krShortName: '스타벅스' },
      KO: { krShortName: '코카콜라' },
      PEP: { krShortName: '펩시' },
      V: { krShortName: '비자' },
      JPM: { krShortName: '제이피모건' },
      PYPL: { krShortName: '페이팔' },
      BAC: { krShortName: '뱅크오브아메리카' },
      MA: { krShortName: '마스터카드' },
      NKE: { krShortName: '나이키' },
      TSLA: { krShortName: '테슬라' },
      GM: { krShortName: '제너럴모터스' },
      LCID: { krShortName: '루시드' },
      ASML: { krShortName: 'ASML' },
      NFLX: { krShortName: '넷플릭스' },
      DIS: { krShortName: '디즈니' },
      CROX: { krShortName: '크록스' },
      WMT: { krShortName: '월마트' },
      COST: { krShortName: '코스트코' },
      PG: { krShortName: 'P&G' },
      HD: { krShortName: '홈디포' },
      JNJ: { krShortName: '존슨앤존슨' },
      PFE: { krShortName: '화이자' },
      UNH: { krShortName: '유나이티드헬스그룹' },
      NVS: { krShortName: '노바티스' },
      XOM: { krShortName: '엑슨모빌' },
      ADSK: { krShortName: '오토데스크' },
      ADBE: { krShortName: '어도비' },
      CRM: { krShortName: '세일즈포스' },
      LULU: { krShortName: '룰루레몬' },
      BABA: { krShortName: '알리바바' },
      ABNB: { krShortName: '에어비앤비' },
      AAL: { krShortName: '아메리칸항공그룹' },
      DAL: { krShortName: '델타항공' },
      LUV: { krShortName: '사우스웨스트항공' },
      PLUG: { krShortName: '플러그파워' },
      PLTR: { krShortName: '팔란티어' },
      U: { krShortName: '유니티' },
      ATVI: { krShortName: '액티비전 블리자드' },
    };

    for (const [sector, symbols] of Object.entries(symbolsBySector)) {
      for (const symbol of symbols) {
        data[symbol].sector = sector;
      }
    }

    return data;
  })();
